import { type NextPageWithLayout } from 'next'
import Head from 'next/head'
import Script from 'next/script'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Flex } from 'components/Layout'
import { environment } from 'constants/environment'
import { SPACE } from 'Theme'
import { prepareGetStaticNavigationProps } from '../utils/prepareGetStaticNavigationProps'

const TITLE = 'Refresh Your Room From the Ground Up'
const DESCRIPTION =
  'Jake Arnold’s highly-anticipated rug collection for Lulu & Georgia is finally here, the holidays are fast approaching, and we’re feeling a little generous. Now’s your chance to refresh your room from the ground up with a $500 Lulu & Georgia gift card and a 25-minute consultation with our co-founder (and celebrity designer) Jake ArnoldEnter your information for a chance to win.'
const URL = `${environment.APP_URL}/JakeArnold-for-LG`

export const JakeArnoldForLG: NextPageWithLayout = () => (
  <>
    <Head>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={TITLE} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta name="twitter:image" content="" />

      <meta property="og:url" content={URL} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={TITLE} />

      <meta property="og:site_name" content={TITLE} />
      <meta property="fb:admins" content="1088490351" />
      <meta property="fb:admins" content="11512735" />
      <meta property="fb:admins" content="1088490312" />
      <meta property="og:description" content={DESCRIPTION} />
    </Head>
    <Flex width="100%" height="100%" justifyContent="center" my={SPACE.PX_15}>
      <div id="vsscript_123262_687333" />
      <Script
        async
        type="text/javascript"
        src="https://app.viralsweep.com/vsa-widget-328e2c-123262.js?sid=123262_687333"
      />
    </Flex>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

JakeArnoldForLG.getLayout = getPublicLayout
